/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class PixiesVsPiratesSoundConfig implements ISoundConfig {

    public static instance:PixiesVsPiratesSoundConfig = new PixiesVsPiratesSoundConfig();

    MAIN_GAME_AMBIANCE:string = "background-music-main";
    RESPIN_GAME_AMBIANCE:string = "background-music-fs";
    static AS_WIN:string = "asWin";
    static AS_WIN_BIG:string = "asWinBig";
    static TINY_WIN:string = "winTiny";
    static SMALL_WIN:string = "winSmall";
    static MEDIUM_WIN:string = "winMedium";
    static LARGE_WIN:string = "winLarge";
    static BIG_WIN_START:string = "bigwinInitialWin";
    static BIG_WIN_LOOP:string = "bigwin";
    static BIG_WIN_END_0:string = "bigwinEnds1";
    static BIG_WIN_END_1:string = "bigwinEnds2";
    static BIG_WIN_END_2:string = "bigwinEnds3";
    static COUNT_UP:string = "countup";
    static COUNT_UP_ENDS:string = "countupEnds";

    static SCATTER_LANDING_1:string = "scatter1";
    static SCATTER_LANDING_2:string = "scatter2";
    static SCATTER_LANDING_3:string = "scatter3";
    static SCATTER_LANDING_4:string = "scatter3";
    static SCATTER_HIGHLIGHT:string = "scatterHighlight";
    static ANTICIPATION:string = "anticipation";
    static ANTICIPATION_FAIL:string = "anticipationFail";

    static XWAYS_LANDING:string = "xwaysLandning";
    static XWAYS_EXPAND:string = "xwaysExpand";
    static XWAYS_NOWIN:string = "xwaysExpandNoWin";

    static FS_INTRO:string = "fsIntro";
    static FSSELECT_SHOWING:string = "fsSelectShowing";
    static FS_SELECT:string = "fsSelect";
    static FS_COLLECT:string = "fsCollect";
    static FS_OUTRO:string = "fsOutro";

    static FS_PIRATE:string = "fsPirate";
    static FS_PIXIE:string = "fsPixie";
    static NUDGE_ODD:string = "nudge1";
    static NUDGE_EVEN:string = "nudge2";
    static NUDGE_END:string = "nudgeEnd";
    static NUDGE_NO_WIN:string = "nudgeNoWin";
    static NUDGE_ONE_TIME:string = "nudgeOneTime";
    static NUDGE_START:string = "nudgeStart";
    static NUDGE_END_ANIMATION:string = "nudgeEndAnimation";

    REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6"];


    constructor() {
        if(PixiesVsPiratesSoundConfig.instance) {
            throw new Error("PixiesVsPiratesSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}